import { render, staticRenderFns } from "./ReceiptItemLocation.vue?vue&type=template&id=1397b83f&scoped=true"
import script from "./ReceiptItemLocation.vue?vue&type=script&lang=js"
export * from "./ReceiptItemLocation.vue?vue&type=script&lang=js"
import style0 from "./ReceiptItemLocation.vue?vue&type=style&index=0&id=1397b83f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1397b83f",
  null
  
)

export default component.exports